import {IAddressResponseData, ICountriesLookup, PaymentFactory} from "@connox/typescript-library";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import {emptyAddress} from "../../checkout/steps/AddressStep/AddressStep";
import window from "../WindowExtended";
import {amazonPayAddressContainerId, cancelAmazonPay, widgetOptions} from "./AmazonPayLibrary";
import {IAmazonPayAddress} from "@connox/typescript-library/types/checkout/requestHandlers/CheckoutRequestHandler";

interface IAmazonPayAddressWidget {
  availableCountries: ICountriesLookup[];
  onAddress: (amazonPayAddress: IAddressResponseData) => void;
  onError: (errorString: string) => void;
}

export interface IAmazonPayAddressType extends IAmazonPayAddress {
  type: number;
}

const AmazonPayAddressWidget: React.FC<IAmazonPayAddressWidget> = (props) => {
  const {checkout} = useCheckoutContext();
  const {t} = useTranslation("checkout");

  useEffect(() => {
    if (!window.amazon) {
      return;
    }

    new window.OffAmazonPayments.Widgets.AddressBook({
      amazonOrderReferenceId: window.orderReferenceId,
      onAddressSelect: async () => {
        try {
          const results = await PaymentFactory.getAmazonPayAddress(window.orderReferenceId);
          const amazonDeliveryAddress = Array.isArray(results)
            ? (results as IAmazonPayAddressType[]).find((result) => result.type === 2)
            : results;
          if (!amazonDeliveryAddress) {
            props.onError("AMAZON_PAY_ERROR");

            return;
          }
          window.amazon.Login.retrieveProfile(window.accessToken, (response) => {
            if (response.error) {
              props.onError(response.error);

              return;
            }
            const email = response.profile.PrimaryEmail;
            const ard = {
              ...emptyAddress,
              city: amazonDeliveryAddress.city,
              countryCode: amazonDeliveryAddress.countryCode,
              email,
              state: amazonDeliveryAddress.state,
              zip: amazonDeliveryAddress.zip,
            };
            props.onAddress(ard);
          });
        } catch (e) {
          props.onError("AMAZON_PAY_ERROR");
        }
      },
      onError: (error) => {
        props.onError(`[AmazonPayAddress] ${error.getErrorCode()}: ${error.getErrorMessage()}`);
      },
      ...widgetOptions,
    }).bind(amazonPayAddressContainerId);
  }, []);

  const cancel = () => {
    cancelAmazonPay();
    void checkout.put({paymentId: null});
  };

  return (
    <div style={{marginBottom: "1rem"}}>
      <div id={amazonPayAddressContainerId} style={{height: "230px", marginBottom: ".5rem"}}>
        {/* Filled by Amazon Pay */}
      </div>
      <span style={{cursor: "pointer", color: "#1ba1e2"}} onClick={cancel}>
        {t("Zahlung mit Amazon Pay abbrechen")}
      </span>
    </div>
  );
};

export default AmazonPayAddressWidget;
